module.exports = __webpack_public_path__ + "static/media/header-logo-catho.45f74b92.png";